/* eslint-disable react-hooks/exhaustive-deps */
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputBase, Paper } from '@mui/material';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';

import { Icons } from '../../../assets/SvgIcons';
import SectionCard from '../../../components/UI/SectionCard/SectionCard';
import TodoCard from '../../../components/UI/TodoCard/TodoCard';
import { PageType, TaskViewType } from '../../../config/enum';
import { FilterIProps } from '../../../config/filter';
import { DateRanger } from '../../../config/range';
import { Section } from '../../../config/section';
import { ComponentHelper } from '../../../helper/Infra';
import { ICTask } from '../../../helper/Interfaces';
import { getAssets } from '../../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postDealTaskList,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import MergefloDependencyFilters from '../components/MergefloDependencyFilter';

interface ListTabProps {
  myTaskList: Array<ICTask>;
}

const BoardTab: FC<ListTabProps> = ({ myTaskList: incomingTaskList }) => {
  const [initialTaskVisible, setInitialTaskVisible] = useState<boolean>(false);
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const { functionalAreas } = useAppSelector(getAssets);

  const componentHelper = new ComponentHelper();
  const dispatch = useAppDispatch();
  const [, setFiilterReset] = React.useState(false);
  const [myTaskList, setMyTaskList] =
    React.useState<ICTask[]>(incomingTaskList);

  /// Filters ////
  const [searchString, setsearchString] = useState('');
  const [likelihoodFilter, setLikelihoodFilter] = useState<FilterIProps[]>([]);
  const [statusFilter, setStatusFilter] = useState<FilterIProps[]>([]);
  const [functionalAreasFilter, setFunctionalAreasFilter] = useState<
    FilterIProps[]
  >([]);
  const [targetFunctionalAreaFilter, setTargetFunctionalAreaFilter] = useState<
    FilterIProps[]
  >([]);
  const [createdDateFilter, setCreateDateFilter] = useState<FilterIProps[]>([]);
  const [createRangeFilter, setCreateRangeFilter] = React.useState<DateRanger>({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  });
  const [progressFilter, setProgressFilter] = useState<FilterIProps[]>([]);
  const [dueDateFilter, setDueDateFilter] = useState<FilterIProps[]>([]);
  const [assigneeFilter, setAssigneeFilter] = useState<FilterIProps[]>([]);
  const [moreFilter, setMoreFilter] = useState<FilterIProps[]>([]);
  const [rangeFilter, setRangeFilter] = React.useState<DateRanger>({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  });
  /// Filters ////

  const updateTaskDate = async (currentTask: ICTask, dueDate: string) => {
    const data = await componentHelper.updateTask({
      id: currentTask.id,
      dueDate: dueDate === '' ? null : dueDate,
    });
    if (data) {
      const newTaskList = [...myTaskList];
      const index = myTaskList.findIndex(emp => emp.id === data.id);
      const newVersion = { ...newTaskList[index] };
      newVersion.dueDate = dueDate === '' ? null : dueDate;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
    }
  };

  const updateTask = async (currentTask: ICTask, username: string) => {
    const data = await componentHelper.updateTask({
      id: currentTask.id,
      assignee: username.length > 0 ? username : null,
    });
    if (data) {
      const newTaskList = JSON.parse(JSON.stringify(myTaskList)) as ICTask[];
      //const newTaskList = [...currentTaskList];
      const index = newTaskList.findIndex(emp => emp.id === data.id);
      const newVersion = newTaskList[index];
      newVersion.assignee = username.length > 0 ? username : null;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
    }
  };

  const updateTaskProperty = async (
    taskId: string,
    taskProperty: string,
    value: any
  ) => {
    const updateTemplate = {
      id: taskId,
    };
    (updateTemplate as any)[taskProperty] = value;

    const data = await componentHelper.updateTask(updateTemplate);
    if (data) {
      const newTaskList = [...myTaskList];
      const index = myTaskList.findIndex(emp => emp.id === data.id);
      const newVersion = { ...newTaskList[index] };
      (newVersion as any)[taskProperty] = value;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
      setMyTaskList([...newTaskList]);
    }
  };

  const updateTaskName = async (currentTask: ICTask, taskName: string) => {
    const data = await componentHelper.updateTask({
      id: currentTask.id,
      name: taskName,
    });
    if (data) {
      const newTaskList = [...myTaskList];
      const index = myTaskList.findIndex(emp => emp.id === data.id);
      const newVersion = { ...newTaskList[index] };
      newVersion.name = taskName;
      newTaskList[index] = newVersion;

      dispatch(postDealTaskList(newTaskList));
      setMyTaskList([...newTaskList]);
    }
  };
  useEffect(() => {
    let pureTaskList = [...incomingTaskList];

    if (statusFilter.length > 0) {
      const newFiltered = [] as ICTask[];
      for (const status of statusFilter) {
        if (status.key === '1') {
          const sort = pureTaskList.filter(
            i => i.dueDate && new Date() > new Date(i.dueDate)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        } else if (status.key === '2') {
          const sort = pureTaskList.filter(
            t =>
              (!t.dueDate && (t.riskCount! > 0 || t.issueCount! > 0)) ||
              (t.dueDate &&
                new Date() < new Date(t.dueDate) &&
                (t.riskCount! > 0 || t.issueCount! > 0))
          );

          for (const s of sort) {
            newFiltered.push(s);
          }
        } else if (status.key === '3') {
          const sort = pureTaskList.filter(
            pt =>
              pt.dueDate &&
              new Date(pt.dueDate) > new Date() &&
              (!pt.riskCount || pt.riskCount === 0) &&
              (!pt.issueCount || pt.issueCount === 0)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        } else {
          const sort = pureTaskList.filter(
            pt =>
              !pt.dueDate &&
              (!pt.riskCount || pt.riskCount === 0) &&
              (!pt.issueCount || pt.issueCount === 0)
          );
          for (const s of sort) {
            newFiltered.push(s);
          }
        }
      }
      console.log('newFiltered', newFiltered);

      pureTaskList = Array.from(new Set(newFiltered as ICTask[]));
    }
    if (functionalAreasFilter.length > 0) {
      pureTaskList = pureTaskList.filter(t =>
        functionalAreasFilter.map(f => f.key).includes(t.playbookFunction ?? '')
      );
    }
    if (searchString.trim() !== '') {
      pureTaskList = pureTaskList.filter(t =>
        t.name?.includes(searchString.trim())
      );
    }
    if (dueDateFilter.length > 0) {
      pureTaskList = pureTaskList.filter(
        t =>
          moment(t.dueDate).toDate() >
            (rangeFilter.selection.startDate as Date) &&
          (rangeFilter.selection.endDate as Date) > moment(t.dueDate).toDate()
      );
    }
    if (createdDateFilter.length > 0) {
      pureTaskList = pureTaskList.filter(
        t =>
          moment(t.createdAt).toDate() >
            (createRangeFilter.selection.startDate as Date) &&
          (createRangeFilter.selection.endDate as Date) >
            moment(t.createdAt).toDate()
      );
    }
    if (moreFilter.length > 0) {
      if (moreFilter.filter(m => m.key === 'hasRisks').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.riskCount && t.riskCount > 0);
      }
      if (moreFilter.filter(m => m.key === 'hasIssues').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.issueCount && t.issueCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'hasDecision').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.decisionCount && t.decisionCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'hasDependencies').length > 0) {
        pureTaskList = pureTaskList.filter(
          t => t.dependenciesCount && t.dependenciesCount > 0
        );
      }
      if (moreFilter.filter(m => m.key === 'uncompleted').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.isCompleted === false);
      }
      if (moreFilter.filter(m => m.key === 'completed').length > 0) {
        pureTaskList = pureTaskList.filter(t => t.isCompleted === true);
      }
    }
    if (assigneeFilter.length > 0) {
      pureTaskList = pureTaskList.filter(t =>
        assigneeFilter.map(i => i.key).includes(t.assignee ?? '')
      );
    }
    if (likelihoodFilter.length > 0) {
      const newFiltered = [] as ICTask[];
      for (const likelihood of likelihoodFilter) {
        if (likelihood.key === 'unassigned') {
          const newCollection = pureTaskList.filter(
            t => !t.issueImpact || t.issueImpact === 'none'
          );
          for (const elem of newCollection) {
            newFiltered.push(elem);
          }
        } else {
          const newCollection = pureTaskList.filter(
            t => t.issueImpact === likelihood.key
          );
          for (const elem of newCollection) {
            newFiltered.push(elem);
          }
        }
      }

      pureTaskList = Array.from(new Set(newFiltered as ICTask[]));
    }
    console.log('pureTaskList', pureTaskList);

    setMyTaskList(pureTaskList);
  }, [
    incomingTaskList,
    statusFilter,
    functionalAreasFilter,
    progressFilter,
    dueDateFilter,
    assigneeFilter,
    moreFilter,
    searchString,
    likelihoodFilter,
    rangeFilter,
  ]);

  return (
    <>
      <div className="h-90p">
        <div
          className="pt-3 pb-3 "
          style={{ paddingLeft: 25, paddingRight: 53 }}
        >
          <div className="invite-playbook-header" style={{ marginBottom: 30 }}>
            <div className="invite-playbook-header-row">
              <div className="search">
                <Paper
                  component="form"
                  sx={{
                    p: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    width: 290,
                    borderRadius: 1,
                    background: '#FAFBFC',
                    border: 2,
                    borderColor: '#DFE1E6',
                    borderStyle: 'solid',
                    boxShadow: 'none',
                    height: 40,
                  }}
                >
                  <IconButton
                    type="submit"
                    sx={{ p: '10px' }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search dependencies"
                    inputProps={{ 'aria-label': 'Search dependencies' }}
                    value={searchString}
                    onChange={evt => setsearchString(evt.target.value)}
                  />
                </Paper>
              </div>
              <MergefloDependencyFilters
                assigneeFilter={assigneeFilter}
                dueDateFilter={dueDateFilter}
                functionalAreasFilter={functionalAreasFilter}
                setFunctionalAreasFilter={setFunctionalAreasFilter}
                statusFilter={statusFilter}
                rangeFilter={rangeFilter}
                setRangeFilter={setRangeFilter}
                progressFilter={progressFilter}
                setProgressFilter={setProgressFilter}
                setMoreFilter={setMoreFilter}
                moreFilter={moreFilter}
                setAssigneeFilter={setAssigneeFilter}
                setDueDateFilter={setDueDateFilter}
                setStatusFilter={setStatusFilter}
                likelihoodFilter={likelihoodFilter}
                setLikelihoodFilter={setLikelihoodFilter}
                createRangeFilter={createRangeFilter}
                createdDateFilter={createdDateFilter}
                setCreateDateFilter={setCreateDateFilter}
                setCreateRangeFilter={setCreateRangeFilter}
                targetFunctionalAreaFilter={targetFunctionalAreaFilter}
                setTargetFunctionalAreaFilter={setTargetFunctionalAreaFilter}
              />
              {statusFilter.length ||
              functionalAreasFilter.length ||
              progressFilter.length ||
              dueDateFilter.length ||
              assigneeFilter.length ||
              likelihoodFilter.length ||
              moreFilter.length ? (
                <div
                  style={{ display: 'flex', cursor: 'pointer' }}
                  id="reset-button"
                  onClick={() => {
                    setStatusFilter([]);
                    setFunctionalAreasFilter([]);
                    setProgressFilter([]);
                    setDueDateFilter([]);
                    setAssigneeFilter([]);
                    setLikelihoodFilter([]);
                    setMoreFilter([]);
                    setFiilterReset(true);
                  }}
                >
                  <div
                    style={{
                      width: 0,
                      height: '20.27px',
                      border: '1px solid #C2C1D0',
                    }}
                  ></div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '0 4px',
                    }}
                  >
                    <div style={{ padding: '0 2px', display: 'flex' }}>
                      <Icons.Cancel width="15" height="15" color="#46426E" />
                    </div>
                    <div
                      style={{
                        color: '#46426E',
                        fontFamily: 'Inter',
                        padding: '0 2px',
                      }}
                    >
                      Reset
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div
            className="customScroll"
            style={{
              whiteSpace: 'nowrap',
              padding: 5,
              overflowX: 'auto',
              height: '75vh',
            }}
          >
            <div
              key={0}
              style={{
                display: 'inline-block',
              }}
            >
              <SectionCard
                currentSection={{ id: '1', name: 'Newly Added' } as Section}
                taskViewType={TaskViewType.BOARD}
                setInitialTaskVisible={setInitialTaskVisible}
                initialTaskVisible={initialTaskVisible}
                updateSection={() => {}}
                pageType={PageType.DEPENDENCIES}
                children={
                  <>
                    {myTaskList?.map(subTask => (
                      <TodoCard
                        key={subTask.id}
                        subTaskCount={
                          dealTaskList.filter(
                            i =>
                              i.parentId === subTask.id && i.type === 'subtask'
                          ).length
                        }
                        subRiskCount={
                          dealTaskList.filter(
                            i => i.parentId === subTask.id && i.type === 'risk'
                          ).length
                        }
                        subIssueCount={
                          dealTaskList.filter(
                            i => i.parentId === subTask.id && i.type === 'issue'
                          ).length
                        }
                        subDecisionCount={
                          dealTaskList.filter(
                            i =>
                              i.parentId === subTask.id && i.type === 'decision'
                          ).length
                        }
                        subDependencyCount={
                          dealTaskList.filter(
                            i =>
                              i.parentId === subTask.id &&
                              i.type === 'dependency'
                          ).length
                        }
                        task={subTask}
                        taskViewType={TaskViewType.BOARD}
                        startDate={subTask.startDate}
                        pageType={PageType.DEPENDENCIES}
                        updateTaskDate={updateTaskDate}
                        updateTaskProperty={updateTaskProperty}
                        updateTaskName={updateTaskName}
                        updateTask={updateTask}
                        shadowTitle={
                          subTask.name === ' '
                            ? (functionalAreas?.find(
                                f => f.id === subTask.dependencySource
                              )?.shortName ?? '') +
                              ' - ' +
                              (functionalAreas?.find(
                                f => f.id === subTask.dependencyTarget
                              )?.shortName ?? '')
                            : subTask.name
                        }
                      />
                    ))}
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoardTab;
